import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import ModalColumn from "../ModalColumn/ModalColumn";
import { RotatingAllenKey } from "../RotatingAllenKey/RotatingAllenKey";
import styles from "./CannotReopenTaskPrompt.module.css";

type CannotReopenTaskPromptProps = {
  visible: boolean;
  onClose: () => void;
};

function CannotReopenTaskPrompt({
  visible,
  onClose,
}: Readonly<CannotReopenTaskPromptProps>) {
  const { t } = useTranslation();

  return (
    <FixaModal
      visible={visible}
      handleCloseBtn={onClose}
      data-testid={"cannot-reopen-task-prompt"}
    >
      <FixaPrompt
        title=""
        titleId=""
        header={null}
        footer={
          <FixaModalFooter>
            <FixaButton
              data-testid="cannot-reopen-task-prompt-close-btn"
              text={t("okIUnderstandString")}
              onClick={onClose}
              type="primary"
            />
          </FixaModalFooter>
        }
      >
        <ModalColumn gap="medium" className={styles["cannotReopenTaskPrompt"]}>
          <RotatingAllenKey />
          <FixaText
            textStyle="Heading.M"
            tagName="h2"
            data-testid="cannot-reopen-task-prompt-title"
          >
            {t("taskCannotBeReopenedPleaseCreateNewTaskString")}
          </FixaText>
        </ModalColumn>
      </FixaPrompt>
    </FixaModal>
  );
}

export default CannotReopenTaskPrompt;
